var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon__check--indeterminate--system icon--style--outline icon--size--large",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M21 3v18H3V3h18m0-2H3a2 2 0 00-2 2v18a2 2 0 002 2h18a2 2 0 002-2V3a2 2 0 00-2-2zm-3 11a1 1 0 00-1-1H7a1 1 0 000 2h10a1 1 0 001-1z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }